export const LOGGEDIN = "LOGGEDIN";
export const TOUR = "TOUR";
export const LOGOUT = "LOGOUT";
